import React, { Component } from 'react'
import { Row, Col, Form, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { ActionDropdown } from '../components'
import MerchantProfile from './profile'
import ContactInfo from '../contactInfo'
import IntegrationInformation from '../integrationInformation'
import { downloadPublicKey, updateMerchantProfile, getMerchantProfileDetail } from '../../../resources/API';
import LoadingModal from '../../../components/modal/LoadingModal';
import SimpleModal from '../../../components/modal/SimpleModal';
import { toCapitalize } from '../../../resources/Utils';
import moment from 'moment';

export default class DebitProfile extends Component {

  constructor(props) {
    super(props)

    this.state = {
      loadingShow: false,
      modal: {
        header: null,
        body: null,
        footer: null,
        show: false,
        variant: 'danger'
      },
      viewChange: null,
      modalViewChangeShow: false,
      action: props.match.params.action,
      merchantProfile: {
        integration: {
          merchantCode: "",
          merchantId: "",
          specialMerchantCode: null,
          status: "",
          merchantCategory: "",
          merchantCategoryName: "",
          type: "REDIRECT",
          retailCustomer: false,
          easyNet: false,
          easyApp: false,
          corporateCustomer: false,
          businessNet: false,
          businessAnywhere: false,
          paymentGateway: false,
          ePayment: false,
          allowSchedulePayment: "Y",
          isCheckCustRef: "Y",
          emailNoti: "Y",
          statementDisplayOption: "detail",
          encryptResMsg: "Y",
          certificate: null,
          certificateFileName: "",
          isMultiAcct : "N",
        },
        subAccountProfile: [{
          subAccountId: null,
          accountNumber: "",
          paymentCallbackUrl: "",
          registerCallbackUrl: "",
          shadowAccounts:[]
        }],
        shadowAccountProfile: [
          {
            shadowAccountId: null,
            shadowAccountNo: "",
            isShadowAccount : ""
          }
        ],
        general: {
          taxId: "",
          tradingName: "",
          merchantName: "",
          merchantCorpId: "",
          businessType: "",
          businessTypeName: "",
          merchantLogo: null,
          merchantLogoFileName: "",
          merchantLogoErrorMessage: ""
        }
      },
      merchantContactInfo: {
        contactDetail: {
          firstName: "",
          lastName: "",
          email: "",
          phoneNo: "",
        },
        address: {
          addressSeqId: "",
          addressInfo: null,
        }
      },
      integrationInformation: {
        generatedBy: "",
        generatedTime: ""
      },
      feeProfile: {
        transactionFee: {
          chargeFrequency: "",
          chargeTo: "",
          currency: "",
          min: "",
          max: "",
          isFlatFee: false
        },
        monthlyFee: {
          feeChargeAccount: "",
          isDbAdvRecieved: false,
          dbAdvRcvMail: "",
        },
        interBranch: {
          isApplicable: false,
          calculationMethod: "",
          fixedValue: "",
          percentageValue: "",
          isCap: false,
          capAmount: "",
          capApply: ""
        },
        interRegion: {
          isApplicable: false,
          calculationMethod: "",
          fixedValue: "",
          percentageValue: "",
          isCap: false,
          capAmount: "",
          capApply: ""
        },
        waiveInfo: {
          isWaive: "N",
          waiveFrom: "",
          waiveTo: "",
          isValidTillCancel: false,
          waiveType: "",
          waiveBy: "",
          waiveAmt: "",
          waivePercentage: ""
        }
      },
      merchantAccountCurrencyList: [],
      onlDDRegOpt: {
        authenOpt: {
          ATM: true,
          Easy: true
        },
        onlDDRegOpt:"ALL",
        currencyInfo: [{ currencyName: "THB" }],
        purposeId: "",
        purposeCode: "",
        purposeDesc: "",
        purposeTerms: "",
      }
    }

  }

  handleSubAccountAdd = () => {
    const blankSubAccountForm = {
      subAccountId: null,
      accountNumber: "",
      paymentCallbackUrl: "",
      registerCallbackUrl: ""
    };
    const { subAccountProfile } = this.state.merchantProfile;
    this.setState({
      merchantProfile: {
        ...this.state.merchantProfile,
        subAccountProfile: [...subAccountProfile, blankSubAccountForm]
      }
    });
  }

  handleDownloadKey = async () => {
    const { downloading } = this.props;
    downloading.set(true);
    await downloadPublicKey();
    downloading.set(false);
  }

  handleSubAccountChange = (index, name, value, format) => {
    let regEx;
    if (format === "NUMERIC") {
      regEx = new RegExp(/^[0-9]+$/);
      if (!regEx.test(value) && value !== '') {
        return;
      }
    } else if (format === "DECIMAL") {
      regEx = new RegExp(/^[0-9.]+$/);
      if (!regEx.test(value) && value !== '') {
        return;
      }
    }
    const { subAccountProfile } = this.state.merchantProfile;
    subAccountProfile[index][name] = value;
    this.setState({
      merchantProfile: {
        ...this.state.merchantProfile,
        subAccountProfile: [...subAccountProfile]
      }
    });
  }

  handleSubAccountDelete = (index) => {
    const { subAccountProfile } = this.state.merchantProfile;
    subAccountProfile.splice(index, 1);

    this.setState({
      merchantProfile: {
        ...this.state.merchantProfile,
        subAccountProfile: [...subAccountProfile]
      }
    });
  }

  handleLogoDelete = () => {
    this.setState({
      merchantProfile: {
        ...this.state.merchantProfile,
        general: {
          ...this.state.merchantProfile.general,
          merchantLogo: null,
          merchantLogoFileName: "",
          merchantLogoErrorMessage: ""
        }
      }
    });
  }

  handleLogoChange = (event) => {
    let mpTemp = this.state.merchantProfile;
    if (event.target.files.length > 1) {
      mpTemp.general.merchantLogoErrorMessage = "Please select only 1 image";
      this.setState({ merchantProfile: mpTemp });
      return;
    }
    if (event.target.files.length === 1) {
      let merchantLogoFileName = event.target.files[0].name;
      let file = event.target.files[0];
      const byte300kB = 300 * 1024;
      if (file.size > byte300kB) {
        mpTemp.general.merchantLogoErrorMessage = "Merchant logo must not exceed 300KB";
        this.setState({ merchantProfile: mpTemp });
        return;
      }
      let parts = merchantLogoFileName.split('.');
      let fileType = parts[parts.length - 1];
      merchantLogoFileName = "logo_" + moment().format("YYYYMMDDhhmmssSSS") + "." + fileType;
      const acceptedFileType = ["PNG", "JPG", "JPEG"];
      if (!(acceptedFileType.includes(fileType.toUpperCase()))) {
        mpTemp.general.merchantLogoErrorMessage = "Merchant logo must be in format of PNG or JPG";
        this.setState({ merchantProfile: mpTemp });
        return;
      }
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        var image = new Image();
        image.src = e.target.result;
        image.onload = (img) => {
          const height = img.target.naturalHeight;
          const width = img.target.naturalWidth;
          if (height !== width) {
            mpTemp.general.merchantLogoErrorMessage = "Merchant logo must be square ratio";
            this.setState({ merchantProfile: mpTemp });
            return;
          }
          mpTemp.general.merchantLogo = img.target.src;
          mpTemp.general.merchantLogoFileName = merchantLogoFileName;
          mpTemp.general.merchantLogoErrorMessage = "";
          this.setState({ merchantProfile: mpTemp });
        };
      }
    }
  }

  handleCertificateChange = (event) => {
    let mpTemp = this.state.merchantProfile;
    if (event.target.files.length === 1) {
      let certificateFileName = event.target.files[0].name;
      let file = event.target.files[0];
      let parts = certificateFileName.split('.');
      let fileType = parts[parts.length - 1];
      certificateFileName = "cert_" + moment().format("YYYYMMDDhhmmssSSS") + "." + fileType;
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        mpTemp.integration.certificateFileName = certificateFileName;
        mpTemp.integration.certificate = e.target.result;
        this.setState({ merchantProfile: mpTemp });
      }
    }
  }

  handleCertificateDelete = () => {
    this.setState({
      merchantProfile: {
        ...this.state.merchantProfile,
        integration: {
          ...this.state.merchantProfile.integration,
          certificate: null,
          certificateFileName: ""
        }
      }
    });
  }

  hasDuplicateSubAccount = () => {
    const { subAccountProfile } = this.state.merchantProfile;
    for (const i in subAccountProfile) {
      for (const j in subAccountProfile) {
        if (i !== j) {
          if ((subAccountProfile[i].accountNumber === subAccountProfile[j].accountNumber) &&
            (subAccountProfile[i].paymentCallbackUrl === subAccountProfile[j].paymentCallbackUrl) &&
            (subAccountProfile[i].registerCallbackUrl === subAccountProfile[j].registerCallbackUrl)
          ) {
            return true;
          }
        }
      }
    }
    return false;
  }

  isValidDate = () => {
    const { waiveFrom, waiveTo } = this.state.feeProfile.waiveInfo;
    return moment(waiveTo).isAfter(waiveFrom) || moment(waiveTo).isSame(waiveFrom);
  }

  compareMinMaxFee = (min, max) => {
    return parseFloat(min) <= parseFloat(max);
  }

  handleSubmitMerchant = (e) => {
    e.preventDefault();

    const { isValidTillCancel, isWaive } = this.state.feeProfile.waiveInfo;
    const { min, max, chargeFrequency } = this.state.feeProfile.transactionFee;

    let header = toCapitalize(this.state.action) + " merchant profile error";
    let body;
    let isValid = true;

    if (chargeFrequency === "T") {
      if (isWaive === "Y" && !isValidTillCancel && !this.isValidDate()) {
        body = "Waive date from should be earlier than waive date to";
        isValid = false;
      }

      if (!this.compareMinMaxFee(min, max)) {
        body = "Maximum fee should be more than or equal to minimum fee";
        isValid = false;
      }
    }

    if (this.hasDuplicateSubAccount()) {
      body = "Sub-account profile is duplicated, please check";
      isValid = false;
    }

    if (isValid) {
      this.merchantProfileAction(this.props.match.params.action);
    } else {
      this.setState({
        modal: {
          header: header,
          body: body,
          show: true,
          variant: "danger"
        }
      });
    }
  }

  handleMerchantProfileActivation = (isActive) => {
    if (isActive) {
      this.merchantProfileAction("activate");
    } else {
      this.merchantProfileAction("inactivate");
    }
  }

  merchantProfileAction = async (action) => {
    const { merchantProfile, merchantContactInfo, feeProfile, onlDDRegOpt} = this.state;
    this.setState({ loadingShow: true });
    const capAction = toCapitalize(action);
    let isMultiAcct = merchantProfile.integration.isMultiAcct;
    if(isMultiAcct === "Y" || isMultiAcct === "A"){
      let shadowAccounts = [];
      merchantProfile.shadowAccountProfile.forEach((value)=>{
        shadowAccounts.push({accountNumber:value.shadowAccountNo,
          isShadowAccount:value.isShadowAccount})
      });
      merchantProfile.subAccountProfile[0]["shadowAccounts"] = shadowAccounts;
    } else if (isMultiAcct === "N" || isMultiAcct === "D"){
      merchantProfile.subAccountProfile.forEach((subAcct)=>{
        subAcct.shadowAccounts=[];
      });
    }  
    const debitMerchantProfileResource = {
      isAction: action.toUpperCase(),
      merchantId: merchantProfile.integration.merchantId,
      merchantProfile: {
        merchantInfo: {
          merchantCode: merchantProfile.integration.merchantCode,
          merchantIntegrationType: merchantProfile.integration.type,
          specialMerchantCode: merchantProfile.integration.specialMerchantCode,
          isActive: merchantProfile.integration.status,
          isMultiAcct: isMultiAcct,
          emailNotification: merchantProfile.integration.emailNoti,
          categoryId: merchantProfile.integration.merchantCategory,
          addressSeqId: merchantContactInfo.address.addressSeqId,
          contactFirstName: merchantContactInfo.contactDetail.firstName,
          contactLastName: merchantContactInfo.contactDetail.lastName,
          contactPhone: merchantContactInfo.contactDetail.phoneNo,
          merchantContactMail: merchantContactInfo.contactDetail.email,
          merchantTaxId: merchantProfile.general.taxId,
          merchantName: merchantProfile.general.merchantName,
          merchantNameTrade: merchantProfile.general.tradingName,
          merchantCorpId: merchantProfile.general.merchantCorpId,
          businessTypeId: merchantProfile.general.businessType,
          merchantLogo: merchantProfile.general.merchantLogo,
          merchantLogoFileName: merchantProfile.general.merchantLogoFileName,
          redirectPaymentOption: {
            retailCustomer: {
              easyNet: merchantProfile.integration.easyNet ? "Y" : "N",
              easyApp: merchantProfile.integration.easyApp ? "Y" : "N"
            },
            corporateCustomer: {
              businessNet: merchantProfile.integration.businessNet ? "Y" : "N",
              businessAnywhere: merchantProfile.integration.businessAnywhere ? "Y" : "N"
            },
            paymentGateway: {
              epayment: merchantProfile.integration.ePayment ? "Y" : "N",
            }
          }
        },
        merchantDDProfile: {
          isCheckCustRef: merchantProfile.integration.isCheckCustRef,
          stmtDisplayOpt: merchantProfile.integration.statementDisplayOption,
          isEncryptResp: merchantProfile.integration.encryptResMsg,
          isAllowSchedulePmt: merchantProfile.integration.allowSchedulePayment,
          merchantSubAcctProfiles: merchantProfile.subAccountProfile,
          certificate: merchantProfile.integration.certificate,
          certificateFileName: merchantProfile.integration.certificateFileName,
          authenOpt: onlDDRegOpt.authenOpt.Easy && onlDDRegOpt.authenOpt.ATM ? "ALL"
          : onlDDRegOpt.authenOpt.Easy ? 'EASY'
          : "ATM",
          accountCurrOpt: onlDDRegOpt.accountCurrOpt,
          currencyInfoList: onlDDRegOpt.currencyInfo,
          purposeId: onlDDRegOpt.purposeId
        }
      },
      feeProfile: {
        chargeFrequency: feeProfile.transactionFee.chargeFrequency,
        chargeTo: feeProfile.transactionFee.chargeTo,
        currencyCode: "764",
        minCharge: feeProfile.transactionFee.min === "" ? null : feeProfile.transactionFee.min,
        maxCharge: feeProfile.transactionFee.max === "" ? null : feeProfile.transactionFee.max,
        isFlatFee: feeProfile.transactionFee.isFlatFee ? "Y" : "N",
        feeChargeAccount: feeProfile.monthlyFee.feeChargeAccount,
        isRcvDebitAdvMail: feeProfile.monthlyFee.isDbAdvRecieved ? "Y" : "N",
        debitAdvRcvMail: feeProfile.monthlyFee.dbAdvRcvMail,
        feeIBIRRequest: {
          isIB: feeProfile.interBranch.isApplicable ? "Y" : "N",
          ibCalType: feeProfile.interBranch.calculationMethod,
          ibFlatFeeAmt: feeProfile.interBranch.fixedValue === "" ? null : feeProfile.interBranch.fixedValue,
          ibPercentage: feeProfile.interBranch.percentageValue === "" ? null : feeProfile.interBranch.percentageValue,
          isIBCap: feeProfile.interBranch.isCap ? "Y" : "N",
          ibCapType: feeProfile.interBranch.capApply,
          ibCapAmt: feeProfile.interBranch.capAmount === "" ? null : feeProfile.interBranch.capAmount,
          isIR: feeProfile.interRegion.isApplicable ? "Y" : "N",
          irCalType: feeProfile.interRegion.calculationMethod,
          irFlatFeeAmt: feeProfile.interRegion.fixedValue === "" ? null : feeProfile.interRegion.fixedValue,
          irPercentage: feeProfile.interRegion.percentageValue === "" ? null : feeProfile.interRegion.percentageValue,
          isIRCap: feeProfile.interRegion.isCap ? "Y" : "N",
          irCapType: feeProfile.interRegion.capApply,
          irCapAmt: feeProfile.interRegion.capAmount === "" ? null : feeProfile.interRegion.capAmount,
        },
        feeWaiveRequest: {
          isWaived: feeProfile.waiveInfo.isWaive,
          waiveFrom: feeProfile.waiveInfo.waiveFrom,
          waiveTo: feeProfile.waiveInfo.waiveTo,
          isValidTillCancel: feeProfile.waiveInfo.isValidTillCancel ? "Y" : "N",
          waiveType: feeProfile.waiveInfo.waiveType,
          waiveBy: feeProfile.waiveInfo.waiveBy,
          waiveAmt: feeProfile.waiveInfo.waiveAmt === "" ? null : feeProfile.waiveInfo.waiveAmt,
          waivePercentage: feeProfile.waiveInfo.waivePercentage === "" ? null : feeProfile.waiveInfo.waivePercentage
        }
      }
    };

    const merchantProfileResponse = await updateMerchantProfile(debitMerchantProfileResource);

    this.setState({ loadingShow: false });
    const footer = <LinkContainer to="/merchant/view" activeClassName="">
      <Button variant="outline-secondary" onClick={this.handleModalClose}>Back to Merchant</Button>
    </LinkContainer>
    if (merchantProfileResponse.status === 200) {
      this.setState({
        modal: {
          header: "Update merchant profile success",
          body: "Your merchant profile has been updated.",
          footer: footer,
          show: true,
          variant: "scb",
          backdrop: 'static'
        }
      });
    } else {
      this.setState({
        modal: {
          header: "Update merchant profile error",
          body: merchantProfileResponse.body.validationMessages[0].message,
          show: true,
          variant: "danger"
        }
      });
    }
  }

  handleModalClose = () => {
    let modal = this.state.modal;
    modal.show = false;
    this.setState({
      modal: modal
    });
  }


  onChange = (section, segment, name, value, format) => {
    let regEx;
    if (format === "NUMERIC") {
      regEx = new RegExp(/^[0-9]+$/);
      if (!regEx.test(value) && value !== '') {
        return;
      }
    } else if (format === "DECIMAL") {
      regEx = new RegExp(/^[0-9.]+$/);
      if (!regEx.test(value) && value !== '') {
        return;
      }
    }

    let { state } = this
    let temp = {
      ...state,
      [section]: {
        ...state[section],
        [segment]: {
          ...state[section][segment],
          [name]: value
        }
      }
    }

    if (name === "") {
      temp = {
        ...state,
        [section]: {
          ...state[section],
          [segment]: value
        }
      }
    }
    this.setState(temp)
  }


  getData = async (action) => {
    this.setState({ loadingShow: true });
    if (action === 'view' || action === 'update') {
      const changeHandlerResponse = await getMerchantProfileDetail();
      let accountCurrencyList = [];
      
      // console.log(JSON.stringify(changeHandlerResponse));
      const { merchantInfo, merchantDDProfile } = changeHandlerResponse.body.merchantProfileResponse.merchantProfileResource;
      const feeProfile = changeHandlerResponse.body.feeProfileResponse.feeProfileResponse;
      const { keyPairResponse, merchantCategory, businessType, merchantAddress } = changeHandlerResponse.body;
      accountCurrencyList  = changeHandlerResponse.body.accountCurrencyList.accountCurrencies;

      let temp = this.state;
      let shadowAccountProfile =[];
      let shadowAccounts = merchantDDProfile.merchantSubAcctProfiles[0]["shadowAccounts"];
      if(shadowAccounts&&shadowAccounts.length>0){
        shadowAccounts.forEach((value)=>{
          shadowAccountProfile.push({
            shadowAccountId : null,
            shadowAccountNo : value.accountNumber,
            isShadowAccount: value.isShadowAccount})
        })
      } else {
        shadowAccountProfile.push({
          shadowAccountId : null,
          shadowAccountNo : "",
          isShadowAccount:""})
      }
      // console.log(shadowAccountProfile);
      temp.merchantProfile = {
        integration: {
          merchantId: merchantInfo.merchantId,
          specialMerchantCode: merchantInfo.specialMerchantCode,
          status: merchantInfo.isActive,
          isMultiAcct: merchantInfo.isMultiAcct ? merchantInfo.isMultiAcct:"N",
          merchantCategory: merchantInfo.categoryId,
          merchantCategoryName: merchantCategory.categoryName,
          type: merchantInfo.merchantIntegrationType,
          allowSchedulePayment: merchantDDProfile.isAllowSchedulePmt,
          isCheckCustRef: merchantDDProfile.isCheckCustRef,
          emailNoti: merchantInfo.emailNotification,
          statementDisplayOption: merchantDDProfile.stmtDisplayOpt,
          encryptResMsg: merchantDDProfile.isEncryptResp,
          certificate: merchantDDProfile.certificate,
          certificateFileName: merchantDDProfile.certificateFileName,
          retailCustomer:
            merchantInfo.redirectPaymentOption.retailCustomer.easyApp === "Y" ||
            merchantInfo.redirectPaymentOption.retailCustomer.easyNet === "Y",
          easyNet: merchantInfo.redirectPaymentOption.retailCustomer.easyNet === "Y",
          easyApp: merchantInfo.redirectPaymentOption.retailCustomer.easyApp === "Y",
          corporateCustomer:
            merchantInfo.redirectPaymentOption.corporateCustomer.businessNet === "Y" ||
            merchantInfo.redirectPaymentOption.corporateCustomer.businessAnywhere === "Y",
          businessNet: merchantInfo.redirectPaymentOption.corporateCustomer.businessNet === "Y",
          businessAnywhere: merchantInfo.redirectPaymentOption.corporateCustomer.businessAnywhere === "Y",
          paymentGateway: merchantInfo.redirectPaymentOption.paymentGateway.epayment === "Y",
          ePayment: merchantInfo.redirectPaymentOption.paymentGateway.epayment === "Y",
        },
        shadowAccountProfile: shadowAccountProfile,
        subAccountProfile: merchantDDProfile.merchantSubAcctProfiles,
        general: {
          taxId: merchantInfo.merchantTaxId,
          tradingName: merchantInfo.merchantNameTrade,
          merchantName: merchantInfo.merchantName,
          merchantCorpId: merchantInfo.merchantCorpId,
          businessType: merchantInfo.businessTypeId,
          businessTypeName: businessType.businessTypeDesc,
          merchantLogo: merchantInfo.merchantLogo,
          merchantLogoFileName: merchantInfo.merchantLogoFileName,
          merchantLogoErrorMessage: ""
        }
      };

      temp.merchantContactInfo = {
        contactDetail: {
          firstName: merchantInfo.contactFirstName,
          lastName: merchantInfo.contactLastName,
          email: merchantInfo.merchantContactMail,
          phoneNo: merchantInfo.contactPhone,
        },
        address: {
          addressSeqId: merchantInfo.addressSeqId,
          addressInfo: merchantAddress,
        }
      };

      temp.integrationInformation = {
        generatedBy: keyPairResponse ? keyPairResponse.generatedBy : "",
        generatedTime: keyPairResponse ? keyPairResponse.generatedTime : ""
      };

      temp.feeProfile = {
        transactionFee: {
          chargeFrequency: feeProfile.chargeFrequency,
          chargeTo: feeProfile.chargeTo,
          currency: feeProfile.currencyCode,
          min: feeProfile.minCharge,
          max: feeProfile.maxCharge,
          isFlatFee: feeProfile.isFlatFee === "Y"
        },
        monthlyFee: {
          feeChargeAccount: feeProfile.feeChargeAccount,
          isDbAdvRecieved: feeProfile.isRcvDebitAdvMail === "Y",
          dbAdvRcvMail: feeProfile.debitAdvRcvMail,
        },
        interBranch: {
          isApplicable: feeProfile.feeIBIRRequest.isIB === "Y",
          calculationMethod: feeProfile.feeIBIRRequest.ibCalType,
          fixedValue: feeProfile.feeIBIRRequest.ibFlatFeeAmt,
          percentageValue: feeProfile.feeIBIRRequest.ibPercentage,
          isCap: feeProfile.feeIBIRRequest.isIBCap === "Y",
          capAmount: feeProfile.feeIBIRRequest.ibCapAmt,
          capApply: feeProfile.feeIBIRRequest.ibCapType
        },
        interRegion: {
          isApplicable: feeProfile.feeIBIRRequest.isIR === "Y",
          calculationMethod: feeProfile.feeIBIRRequest.irCalType,
          fixedValue: feeProfile.feeIBIRRequest.irFlatFeeAmt,
          percentageValue: feeProfile.feeIBIRRequest.irPercentage,
          isCap: feeProfile.feeIBIRRequest.isIRCap === "Y",
          capAmount: feeProfile.feeIBIRRequest.irCapAmt,
          capApply: feeProfile.feeIBIRRequest.irCapType
        },
        waiveInfo: {
          isWaive: feeProfile.feeWaiveRequest.isWaived,
          waiveFrom: feeProfile.feeWaiveRequest.waiveFrom,
          waiveTo: feeProfile.feeWaiveRequest.waiveTo,
          isValidTillCancel: feeProfile.feeWaiveRequest.isValidTillCancel === "Y",
          waiveType: feeProfile.feeWaiveRequest.waiveType,
          waiveBy: feeProfile.feeWaiveRequest.waiveBy,
          waiveAmt: feeProfile.feeWaiveRequest.waiveAmt,
          waivePercentage: feeProfile.feeWaiveRequest.waivePercentage
        }
      };
      temp.merchantAccountCurrencyList = accountCurrencyList;

      temp.onlDDRegOpt = {
        authenOpt: merchantDDProfile.authenOpt === "ALL" ? {
          ATM: true,
          Easy: true
        } : merchantDDProfile.authenOpt === "ATM" ? {
          ATM: true,
          Easy: false
        } : merchantDDProfile.authenOpt === "EASY" ? {
          ATM: false,
          Easy: true
        }: {
          ATM: true,
          Easy: true
        },
        accountCurrOpt:merchantDDProfile.accountCurrOpt?merchantDDProfile.accountCurrOpt:"THB",
        currencyInfo: merchantDDProfile.currencyInfoList ? merchantDDProfile.currencyInfoList: [{currencyName:"THB"}] ,
        purposeId: merchantDDProfile?.purposeId ? merchantDDProfile?.purposeId : "",
        purposeCode: merchantDDProfile?.purposeCode ? merchantDDProfile?.purposeCode : "",
        purposeDesc: merchantDDProfile?.purposeDesc ? merchantDDProfile?.purposeDesc : "",
        purposeTerms: merchantDDProfile?.purposeTerms ? merchantDDProfile?.purposeTerms : "",
      };
      this.setState(temp);
    }
    this.setState({ loadingShow: false});
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match.params.action !== nextProps.match.params.action) {
      this.setState({
        action: nextProps.match.params.action,
      });
      this.getData(nextProps.match.params.action);
    }
  }

  componentDidMount() {
    this.getData(this.state.action);
  }

  render() {

    const { merchantProfile, merchantContactInfo, integrationInformation, action, loadingShow, modal, onlDDRegOpt, merchantAccountCurrencyList } = this.state
    const { role } = this.props;
    if (!['update', 'view'].includes(action)) {
      window.location = '/notfound';
    }
    if (!role.includes("DD_ACCOUNT_PROFILE")) {
      window.location = '/unauthorized';
    }
    console.log({...merchantProfile});
    return (
      <Row className="mx-auto card-width-1200 mt-4">
        {action === "view" &&
          <ActionDropdown
            {...this.props}
          />
        }
        <Form onSubmit={this.handleSubmitMerchant}>
          <MerchantProfile
            className="shadow-sm mx-auto mt-2 card-width-1200"
            action={action}
            onlDDRegOpt={onlDDRegOpt}
            merchantAccountCurrencyList={merchantAccountCurrencyList}
            onLogoChange={this.handleLogoChange}
            onLogoDelete={this.handleLogoDelete}
            onSubAccountAdd={this.handleSubAccountAdd}
            onSubAccountDelete={this.handleSubAccountDelete}
            onSubAccountChange={this.handleSubAccountChange}
            onCertificateChange={this.handleCertificateChange}
            onCertificateDelete={this.handleCertificateDelete}
            {...merchantProfile} />

          <ContactInfo
            className="shadow-sm mx-auto mt-5 card-width-1200"
            onChange={(segment, name, value, format) => this.onChange("merchantContactInfo", segment, name, value, format)}
            action={action}
            {...merchantContactInfo} />

          <IntegrationInformation
            onDownload={this.handleDownloadKey}
            className="shadow-sm mx-auto mt-5 card-width-1200"
            {...integrationInformation} />

          <Row className="mx-auto mt-5 mb-5">
            {action === 'update' &&
              <Col sm={3} className="p-0">
                <LinkContainer
                  to={{
                    pathname: "/merchant/view"
                  }}
                  activeClassName="">
                  <Button variant="outline-secondary" block>Discard Edit</Button>
                </LinkContainer>
              </Col>
            }
            {
              action === 'create' ?
                <Col sm={{ span: 3, offset: 6 }} className="p-0">
                  <Button type="submit" variant="scb" block>Create Merchant</Button>
                </Col>
                : action === 'update' ?
                  <Col sm={{ span: 3, offset: 6 }} className="p-0">
                    <Button type="submit" variant="scb" block>Update Merchant</Button>
                  </Col>
                  :
                  <></>
            }
          </Row>

        </Form>
        <LoadingModal show={loadingShow} />
        <SimpleModal
          modal={modal}
          onClose={this.handleModalClose}
        />
      </Row>
    )
  }
}
